declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

let initialized = false;

export function initAnalytics(): void {
  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
  if (!measurementId || initialized) return;

  // Load gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  // Initialize dataLayer and gtag function
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, { send_page_view: false });

  initialized = true;
}

export function trackPageView(path: string): void {
  if (!initialized) return;
  window.gtag('event', 'page_view', {
    page_path: normalizePath(path),
    content_group: getContentGroup(path),
  });
}

function normalizePath(path: string): string {
  // Replace UUIDs and numeric IDs with placeholders so GA groups them
  return path
    .replace(/\/leagues\/[^/]+\/members\/[^/]+\/roster$/, '/leagues/:id/members/:memberId/roster')
    .replace(/\/leagues\/[^/]+$/, '/leagues/:id')
    .replace(/\/tournaments\/[^/]+$/, '/tournaments/:id')
    .replace(/\/join\/[^/]+$/, '/join/:code');
}

function getContentGroup(path: string): string {
  if (path === '/leagues') return 'Leagues List';
  if (path === '/leagues/create') return 'Create League';
  if (/^\/leagues\/[^/]+\/members\/[^/]+\/roster$/.test(path)) return 'Roster Selection';
  if (/^\/leagues\/[^/]+$/.test(path)) return 'League Details';
  if (path === '/tournaments') return 'Tournaments List';
  if (path === '/tournaments/create') return 'Create Tournament';
  if (/^\/tournaments\/[^/]+$/.test(path)) return 'Tournament Details';
  if (path.startsWith('/blog')) return 'Blog';
  if (path.startsWith('/admin')) return 'Admin';
  if (path === '/') return 'Landing';
  if (path === '/login') return 'Login';
  if (path === '/profile') return 'Profile';
  if (path.startsWith('/join/')) return 'Join League';
  if (path === '/about') return 'About';
  if (path === '/how-it-works') return 'How It Works';
  if (path === '/faq') return 'FAQ';
  if (path === '/contact') return 'Contact';
  if (path === '/privacy') return 'Privacy Policy';
  if (path === '/terms') return 'Terms of Service';
  return 'Other';
}

export function identifyUser(userId: string): void {
  if (!initialized) return;
  window.gtag('set', { user_id: userId });
}
